/**
 * Badge — compact status/label pill (order statuses, referral counters, tags).
 *
 * Tone maps to semantic colors; ``gold`` is reserved for highlight states.
 */
import type { HTMLAttributes, ReactNode } from "react";

import { cn } from "../utils/cn";
import styles from "./Badge.module.css";

export type BadgeTone =
  | "neutral"
  | "gold"
  | "amethyst"
  | "success"
  | "warning"
  | "danger";

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  readonly tone?: BadgeTone;
  /** Add a small leading status dot. Defaults to ``false``. */
  readonly dot?: boolean;
  readonly children?: ReactNode;
}

export function Badge({
  tone = "neutral",
  dot = false,
  className,
  children,
  ...rest
}: BadgeProps): JSX.Element {
  return (
    <span className={cn(styles.badge, styles[tone], className)} {...rest}>
      {dot ? <span className={styles.dot} aria-hidden="true" /> : null}
      {children}
    </span>
  );
}
